<template>
  <nav class="navbar navbar-expand navbar-light">
    <div id="" class="navbar-collapse">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="35"
        fill="currentColor"
        class="bi bi-list d-xl-none d-md-none d-sm-none"
        viewBox="0 0 16 16"
        @click.prevent="showSidebar"
      >
        <path
          fill-rule="evenodd"
          d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
        />
      </svg>
      <!--        <button type="button" id="sidebarCollapse" class="btn btn-info d-xl-none d-md-none d-sm-none">-->
      <!--          <i class="fas fa-align-left"></i>-->
      <!--          <span >Menu</span>-->
      <!--        </button>-->

      <div class="namePage" style="vertical-align: middle">
        <h3 style="color: #6e3f80; font-weight: 600; margin-top: 15px">
          {{ getNamePage }}
        </h3>
      </div>

      <ul
        class="navbar-nav ms-auto d-flex justify-content-center align-items-center"
      >
        <!-- Authenticated -->
        <li v-if="user">
          <Notification />
        </li>
        <li v-if="user" class="navbar-cart">
          <ShoppingCart />
        </li>
        <li v-if="user" class="nav-item dropdown">
          <a
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img
              v-if="user.profile.avatarUrl"
              :src="user.profile.avatarUrl"
              class="rounded-circle profile-photo mr-1"
            />
            <img
              v-else
              :src="user.photo_url"
              class="rounded-circle profile-photo mr-1"
            />
          </a>
          <div class="dropdown-menu" style="margin-left: -120px">
            <router-link
              :to="{ name: 'Manage Account' }"
              class="dropdown-item pl-3"
            >
              <img
                v-if="this.$route.name === 'Manage Account'"
                :src="
                  getImageUrl('/images/user-menu-icons/settings-active.png')
                "
              />
              <img
                v-else
                :src="
                  getImageUrl('/images/user-menu-icons/settings-disable.png')
                "
              />
              <span>Settings</span>
            </router-link>

            <router-link
              :to="{ name: 'Curl Profile' }"
              class="dropdown-item pl-3"
            >
              <img
                v-if="this.$route.name === 'Curl Profile'"
                :src="
                  getImageUrl('/images/user-menu-icons/curl-profile-active.png')
                "
              />
              <img
                v-else
                :src="
                  getImageUrl(
                    '/images/user-menu-icons/curl-profile-disable.png'
                  )
                "
              />
              <span>Curl profile</span>
            </router-link>

            <router-link :to="{ name: 'Insights' }" class="dropdown-item pl-3">
              <img
                v-if="this.$route.name === 'Insights'"
                :src="getImageUrl('/images/user-menu-icons/insight-active.png')"
              />
              <img
                v-else
                :src="
                  getImageUrl('/images/user-menu-icons/insight-disable.png')
                "
              />
              <span>Insights Page</span>
            </router-link>

            <router-link
              v-if="isAdmin"
              :to="{ path: '/admin' }"
              class="dropdown-item pl-3"
            >
              <img
                v-if="
                  this.$route.path === '/admin/users' ||
                  this.$route.path === '/admin/insights' ||
                  this.$route.path === '/admin/methods' ||
                  this.$route.path === '/admin/monitoring' ||
                  this.$route.path === '/admin/regimen'
                "
                :src="getImageUrl('/images/user-menu-icons/admin-active.png')"
              />
              <img
                v-else
                :src="getImageUrl('/images/user-menu-icons/admin-disable.png')"
              />
              <span>Admin</span>
            </router-link>

            <div class="dropdown-divider" />
            <a href="#" class="dropdown-item pl-3" @click.prevent="logout">
              <img
                v-if="this.$route.path === '/login'"
                :src="getImageUrl('/images/user-menu-icons/exit-active.png')"
              />
              <img
                v-else
                :src="getImageUrl('/images/user-menu-icons/exit-disable.png')"
              />
              <span>Logout</span>
            </a>
          </div>
        </li>
        <!-- Guest -->
        <template v-else>
          <li class="nav-item">
            <router-link
              :to="{ name: 'login' }"
              class="nav-link"
              active-class="active"
            >
              Login
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'Sign Up' }"
              class="nav-link"
              active-class="active"
            >
              Register
            </router-link>
          </li>
        </template>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
import ShoppingCart from "./ShoppingCart";
import profileMixin from "@/mixins/profileMixin";
import Notification from "./Notification";

export default {
  components: { Notification, ShoppingCart },
  mixins: [profileMixin],
  data: () => ({
    sidebar: false,
  }),
  computed: {
    ...mapGetters(["user"]),

    isAdmin() {
      return !!this.user.roles.filter((role) => {
        return role.name === "admin";
      }).length;
    },

    getNamePage() {
      return this.$route.name;
    },
  },
  methods: {
    showSidebar() {
      if (this.sidebar) {
        const elem = document.getElementById("sidebar");
        elem.classList.add("active");
      } else {
        const elem = document.getElementById("sidebar");
        elem.classList.remove("active");
      }

      this.sidebar = !this.sidebar;
    },
    async logout() {
      // Log out the user.
      await this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "login" });
      });
    },
  },
};
</script>

<style scoped>
.navbar {
  z-index: 9999;
}
.dropdown-menu span {
  color: #939eab;
}

.dropdown-menu img {
  height: 15px;
  width: 15px;
  margin-right: 10px;
}

.router-link-active {
  height: 31px !important;
  padding: 0.5rem 1rem !important;
}

.router-link-active span {
  color: #6e3f80;
  padding-left: 5px !important;
}

.profile-photo {
  width: 2rem;
  height: 2rem;
  margin: -0.375rem 0;
}
.navbar {
  padding: 0.5rem 1rem;
  background-color: #fafbfc;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue